/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */

import ErrorAlert from "../components/PantallesBKI/Alertas/ErrorAlert";
import { postDownloadDocument } from "../serveis/serveiDownloadDocument";

export function useDownloadDocument() {
  const postDades = async (data, id) => {
    try {
      const dades = await postDownloadDocument(data, id);

      if (dades != null) {

        // Descodificamos los datos base64 a un ArrayBuffer
        const arrayBuffer = Uint8Array.from(atob(dades.dadesDocument), (c) => c.charCodeAt(0)).buffer;

        const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });

        // Creamos un enlace para descargar el blob
        const url = window.URL.createObjectURL(blob);

        // Creamos un elemento <a> para el enlace de descarga
        const link = document.createElement("a");
        link.href = url;
        link.download = dades.nomFitxer;
        document.body.appendChild(link);

        // Simula un clic en el enlace para iniciar la descarga
        link.click();

        // Elimina el enlace del documento
        document.body.removeChild(link);

        // Libera el objeto URL creado
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      ErrorAlert(
        "Error al descarregar el document.",
        10000
      );
    }
  };

  return {
    postDades,
  };
}
